import { useImageReady } from './useImageReady';

export interface BackdropProps {
  /** Photo URL for the upper portion of the page; null hides the photo layer. */
  bgImageUrl: string | null;
  /**
   * `'cover'` crops the image to fill viewport (modern Pack default).
   * `'auto'` preserves intrinsic image scale, centred (classic Pack and
   * JustPulledPage's choice — keeps stadium/lawn art at native scale).
   * Defaults to `'cover'`.
   */
  fit?: 'cover' | 'auto';
}

export function Backdrop({ bgImageUrl, fit = 'cover' }: BackdropProps) {
  const ready = useImageReady(bgImageUrl);
  return (
    <>
      <div
        aria-hidden
        data-testid="backdrop-gradient"
        className="pointer-events-none fixed inset-0 -z-20"
        style={{ backgroundImage: 'var(--ui-bg-gradient)' }}
      />
      {bgImageUrl && (
        <div
          aria-hidden
          data-testid="backdrop-photo"
          data-ready={ready ? 'true' : 'false'}
          className="pointer-events-none fixed left-0 right-0 top-0 -z-10 transition-opacity duration-700 ease-out"
          style={{
            height: '100vh',
            opacity: ready ? 1 : 0,
            backgroundImage: `url('${bgImageUrl}')`,
            backgroundSize: fit,
            backgroundPosition: 'center center',
            backgroundRepeat: 'no-repeat',
            maskImage:
              'linear-gradient(180deg, black 0%, black 60%, transparent 100%)',
            WebkitMaskImage:
              'linear-gradient(180deg, black 0%, black 60%, transparent 100%)',
          }}
        />
      )}
    </>
  );
}
